import { Tag } from 'mojo-tag';

import { AssociationFilter, ExperienceFilter, Location } from '@shared/models';

export interface CandidatesFilter {
  /** required when enableLocationFilter true */
  locations?: Location[];
  keywords: Tag[];
  jobTitles: Tag[];
  schools: Tag[];
  companies: Tag[];
  fieldOfStudy: Tag[];
  minimumDegree: string;
  skills?: Tag[];
  locationMilesRadius: number;
  /** required when enableYOEFilter true */
  experiences?: ExperienceFilter;
  candidateNames?: (string | Tag)[];
  favorites?: boolean;
  silver?: boolean;
  alumni?: boolean;
  warning?: boolean;
  enableLocationFilter?: boolean;
  internalOnTop?: boolean;
  referralOnTop?: boolean;
  enableYOEFilter?: boolean;
  referral?: boolean;
  resumeUploadDate?: { label: string; value: string | null };
}

export interface CandidatePageFilter {
  association: AssociationFilter;
}

export const getCandidatePageKey = (id) => `CandidateFilter-${id}`;
